module.exports = __webpack_public_path__ + "img/slider_1.a354b9f3.png";